import React from 'react';
import './Nav.css';

const Nav = () => {
  return (
    <nav className="nav">
      <ul className="nav-list">
        <li><a href="/">Home</a></li>
        <li><a href="/reserve">Reserve a Table</a></li>
        <li><a href="/menu">Our Menu</a></li>
        <li><a href="/contact">Contact</a></li>
      </ul>
    </nav>
  );
};

export default Nav;